module.exports = __webpack_public_path__ + "img/favicon.f20733ac.png";